module.exports = {

  title: '选座Web',


  baseURL:"https://lcy.mizushio.top:8034"
  // baseURL:"http://localhost:8034"
}
